// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g2FXVLr3Bmr4QOao6jAI{width:100%;height:100%;display:flex}.g2FXVLr3Bmr4QOao6jAI .zYmMnQLHR7iATOVcQwlC{height:100%;max-height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.g2FXVLr3Bmr4QOao6jAI .zYmMnQLHR7iATOVcQwlC .pmLPSrBkmykVbU1RZwr0{height:100%;width:100%;display:flex;flex:1 1 90%}.g2FXVLr3Bmr4QOao6jAI .zYmMnQLHR7iATOVcQwlC p{flex:0 0 30px}.g2FXVLr3Bmr4QOao6jAI ._fAoy926tM2nJBFy76ye{line-height:1.5rem;overflow:hidden;height:100%;position:relative;margin-right:-12px}.g2FXVLr3Bmr4QOao6jAI .g2J2iV8Ic_MAJmC6Tj8v{margin-bottom:16px}.g2FXVLr3Bmr4QOao6jAI h3{color:var(--color-primary)}.g2FXVLr3Bmr4QOao6jAI .rmNgQ3Pwn0pu7XukPSyu{font-size:12px;margin-top:1rem;color:var(--color-sa-gray)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `g2FXVLr3Bmr4QOao6jAI`,
	"rightComponent": `zYmMnQLHR7iATOVcQwlC`,
	"videoBlock": `pmLPSrBkmykVbU1RZwr0`,
	"accordion": `_fAoy926tM2nJBFy76ye`,
	"description": `g2J2iV8Ic_MAJmC6Tj8v`,
	"caption": `rmNgQ3Pwn0pu7XukPSyu`
};
export default ___CSS_LOADER_EXPORT___;
